import { LEADERSHIP_IMAGES } from "@/lib/utils";
const LeadershipImageGrid = () => {
  return (
    <div className="relative w-full max-w-[800px] mx-auto">
      {LEADERSHIP_IMAGES.map((img, index) => (
        <img
          key={index}
          src={img.src}
          alt={img.alt}
          className={img.className}
          style={img.style}
        />
      ))}
    </div>
  );
};

export default LeadershipImageGrid;
